import Body from "./components/Body";
import Header from "./components/Header";

import logo from "./assets/logo.png";

const App = () => {
  return (
    <div className="bg-zinc-900 h-full w-full">
      <Header title={"Hustler's University"} logo={logo} />
      <Body />
    </div>
  );
};

export default App;
